import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const item = event.currentTarget.closest("[data-accordion-target='item']")
    const content = item.querySelector("[data-content]")
    const icon = item.querySelector("[data-icon]")

    if (content.classList.contains("hidden")) {
      this.itemTargets.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.querySelector("[data-content]").classList.add("hidden")
          otherItem.querySelector("[data-icon]").classList.remove("rotate-180")
        }
      })
      content.classList.remove("hidden")
      icon.classList.add("rotate-180")
    } else {
      content.classList.add("hidden")
      icon.classList.remove("rotate-180")
    }
  }
}
